/**
 * NOTAS INFINITAS - Auto-add bonus products to cart
 * Quand le produit principal est ajouté, les 3 bonus sont ajoutés automatiquement
 */

(function() {
  'use strict';

  // Configuration des IDs
  const CONFIG = {
    // ID du produit principal qui déclenche l'ajout des bonus
    mainProductVariantId: 49767719272790,
    
    // IDs des produits bonus à ajouter automatiquement
    bonusVariantIds: [
      50467665019222, // 3 revisiones incluidas
      50467667149142, // 2ª versión ofrecida
      50467714957654  // Entrega en 48h garantizada
    ]
  };

  // Fonction pour vérifier si un variant est dans le panier
  async function isVariantInCart(variantId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.items.some(item => item.variant_id === variantId);
    } catch (error) {
      console.error('Erreur lors de la vérification du panier:', error);
      return false;
    }
  }

  // Fonction pour ajouter un produit au panier
  async function addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });
      return await response.json();
    } catch (error) {
      console.error('Erreur lors de l\'ajout au panier:', error);
      return null;
    }
  }

  // Fonction pour ajouter tous les bonus
  async function addBonusProducts() {
    console.log('🎁 Ajout automatique des bonus Notas Infinitas...');
    
    for (const bonusId of CONFIG.bonusVariantIds) {
      const alreadyInCart = await isVariantInCart(bonusId);
      
      if (!alreadyInCart) {
        await addToCart(bonusId, 1);
        console.log(`✅ Bonus ${bonusId} ajouté au panier`);
      } else {
        console.log(`ℹ️ Bonus ${bonusId} déjà dans le panier`);
      }
    }
    
    console.log('🎉 Tous les bonus ont été traités !');
  }

  // Fonction principale qui intercepte les ajouts au panier
  function initAutoAddBonuses() {
    // Intercepter le fetch pour détecter les ajouts au panier
    const originalFetch = window.fetch;
    
    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      
      // Vérifier si c'est un ajout au panier
      const url = args[0];
      if (typeof url === 'string' && url.includes('/cart/add')) {
        // Attendre un peu que l'ajout soit traité
        setTimeout(async () => {
          // Vérifier si le produit principal est dans le panier
          const mainProductInCart = await isVariantInCart(CONFIG.mainProductVariantId);
          
          if (mainProductInCart) {
            await addBonusProducts();
            
            // Rafraîchir le cart drawer si disponible
            refreshCartDrawer();
          }
        }, 500);
      }
      
      return response;
    };

    // Aussi intercepter les formulaires d'ajout au panier classiques
    document.addEventListener('submit', async function(e) {
      const form = e.target;
      if (form.action && form.action.includes('/cart/add')) {
        setTimeout(async () => {
          const mainProductInCart = await isVariantInCart(CONFIG.mainProductVariantId);
          
          if (mainProductInCart) {
            await addBonusProducts();
            refreshCartDrawer();
          }
        }, 1000);
      }
    });

    console.log('🚀 Auto-add bonuses initialisé pour Notas Infinitas');
  }

  // Fonction pour rafraîchir le cart drawer de Shrine
  function refreshCartDrawer() {
    // Méthode 1: Déclencher un événement personnalisé
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
    // Méthode 2: Simuler un clic sur l'icône du panier pour rafraîchir
    setTimeout(() => {
      // Chercher le bouton du cart drawer de Shrine
      const cartTrigger = document.querySelector('[data-cart-trigger], .cart-icon, .header__cart-btn, [href="/cart"]');
      if (cartTrigger) {
        // Déclencher un refresh via l'API Shrine si disponible
        if (window.Shrine && window.Shrine.cartDrawer) {
          window.Shrine.cartDrawer.refresh();
        }
      }
      
      // Méthode 3: Recharger le contenu du cart via AJAX
      fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(html => {
          const cartDrawer = document.querySelector('.cart-drawer, [data-cart-drawer], #cart-drawer');
          if (cartDrawer) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCartContent = doc.querySelector('.cart-drawer, [data-cart-drawer], #cart-drawer');
            if (newCartContent) {
              cartDrawer.innerHTML = newCartContent.innerHTML;
            }
          }
        })
        .catch(err => console.log('Cart refresh via section failed, trying alternative...'));
        
    }, 300);
  }

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoAddBonuses);
  } else {
    initAutoAddBonuses();
  }

})();